export const KEEP_WARM_INPUT = 'KEEP_WARM_INPUT' as const;
export const KEEP_WARM_OUTPUT = 'KEEP_WARM_OUTPUT' as const;
